import React, { useEffect, useState } from "react";
import { getAll } from "../../api/API";
import { useNavigate } from "react-router-dom";

const ScrollEvents = ({ selectedEventId }) => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchEvents() {
      try {
        const data = await getAll("events");
        setEvents(data.docs || data);
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
    }

    fetchEvents();
  }, []);

  const formatEventDate = (dateFrom, dateTo) => {
    if (!dateFrom) return "TBA";
    const start = new Date(dateFrom);
    const end = dateTo ? new Date(dateTo) : null;

    const options = { day: "2-digit", month: "short" };

    if (end && start.toDateString() === end.toDateString()) {
      return start.toLocaleDateString("en-GB", options).toUpperCase();
    } else if (end) {
      return `${start
        .toLocaleDateString("en-GB", options)
        .toUpperCase()} - ${end
        .toLocaleDateString("en-GB", options)
        .toUpperCase()}`;
    } else {
      return start.toLocaleDateString("en-GB", options).toUpperCase();
    }
  };

  const getOrganizerName = (event) => {
    const org = event.organizers?.[0]?.member;
    if (org) {
      return `${org.firstName} ${org.lastName}`;
    }
    return "TBA";
  };

  const filteredEvents = events
    .filter((event) => event.eventId !== selectedEventId)
    .slice(0, 3);

  return (
    <div className="container my-4">
      {filteredEvents.length > 0 ? (
        filteredEvents.map((event) => (
          <div
            key={event.eventId}
            className="card mb-4 border-0 shadow-sm rounded-4 bg-primary text-white"
          >
            <div className="row g-0 align-items-stretch">
              {/* Left Side */}
              <div className="col-md-8 col-12 d-flex flex-column justify-content-between p-4">
                <div className="text-start">
                  <h2
                    className="fw-bold mb-3 bg-tertiary"
                    style={{
                      display: "inline-block",
                      padding: "4px 10px",
                      borderRadius: "6px",
                    }}
                  >
                    {formatEventDate(event.dateFrom, event.dateTo)},{" "}
                    {event.venue?.toUpperCase() ?? "ONLINE"}
                  </h2>

                  <h6 className="fw-bold mb-2" style={{ maxWidth: "100%" }}>
                    {event.name}
                  </h6>

                  <p className="small mb-0">
                    ORGANIZER: {getOrganizerName(event)}
                  </p>
                </div>

                <button
                  className="btn btn-success mt-3 bg-secondary text-primary"
                  onClick={() => navigate(`/events/${event.eventId}`)}
                >
                  View Details
                </button>
              </div>

              {/* Right Side */}
              <div className="col-md-4 col-12 text-end d-flex align-items-center justify-content-end p-3">
                <img
                  src={event.image?.url || "/assets/images/default.jpg"}
                  alt={event.name}
                  style={{
                    width: "130px",
                    height: "150px",
                    objectFit: "contain",
                    borderRadius: "8px",
                    backgroundColor: "white",
                  }}
                />
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-center">No events available.</p>
      )}
    </div>
  );
};

export default ScrollEvents;
